import * as React from 'react';

export const ErrorInfo: React.FC<React.PropsWithChildren<{
  message: string;
  description?: string;
  refreshAction?: boolean;
}>> = ({ message, description, refreshAction, children }) => {
  return (
    <div>
      <h1>{message}</h1>
      {description && <div>{description}</div>}
      {refreshAction && (
        <div>
          <button onClick={window.location.reload}>Přenačíst aplikaci</button>
        </div>
      )}
      {children && <div>{children}</div>}
    </div>
  );
};
